import { Locales } from 'shared/assets/localization';
import { ID } from 'shared/types/id';

import { createPushToken } from './create-push-token';
import { getPushToken } from './get-push-token';

export const setPushTokenOnUser = async (userId: ID, locale: Locales) => {
  if ('Notification' in window && Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return;
    }
  }

  const token = await getPushToken(userId);

  if (token) {
    await createPushToken(userId, token, locale);
  }
};
